import { TextField, TextFieldProps } from '@mui/material';

/**
 * Textfield с безопасным onBlur
 * @param root0 - пропсы
 * @param root0.onBlur - обработчик onBlur
 */
export const BlurGuardTextfield = ({ onBlur, ...props }: TextFieldProps) => {
  return (
    <TextField
      onBlur={event => {
        if (event) onBlur?.(event);
      }}
      {...props}
    />
  );
};
